<div class="flex w-full flex-col items-center justify-center gap-5">
  <div class="flex w-full max-w-7xl flex-col gap-5">
    <div class="bg-lightGrayish flex w-full flex-col gap-4 p-5 lg:gap-7">
      <app-text-content-box [headline]="'Submit Feedback'" [headerIcon]="'📓'"></app-text-content-box>
      <div class="flex flex-col items-center">
        <div class="relative flex w-full flex-col gap-5 lg:items-end">
          <textarea
            [(ngModel)]="feedback.text"
            class="border-sunflowerGold bg-paleOrange w-full resize-none border-2 p-5 outline-none placeholder:text-gray-400"
            data-cy="feedback-text-area"
          ></textarea>
          <div class="flex w-full flex-col">
            <span class="w-full text-sm">Link to files and documents (optional):</span>
            <input
              [(ngModel)]="feedback.fileUrl"
              type="text"
              class="mt-2 border-2 p-2 text-xs"
              data-cy="fb-feedback-url"
              placeholder="Insert OneDrive link here"
            />
          </div>
          <div class="flex w-full flex-wrap items-center gap-4 max-lg:justify-center">
            <app-badge
              (feedbackOptionSelected)="onBadgeClick($event)"
              [selectedCategory]="feedback.category"
              [feedbackCategory]="FeedbackCategory.SAVING"
              data-cy="fb-category-saving"
            ></app-badge>
            <app-badge
              (feedbackOptionSelected)="onBadgeClick($event)"
              [selectedCategory]="feedback.category"
              [feedbackCategory]="FeedbackCategory.IMPROVEMENT"
              data-cy="fb-category-improvement"
            ></app-badge>
            <app-badge
              (feedbackOptionSelected)="onBadgeClick($event)"
              [selectedCategory]="feedback.category"
              [feedbackCategory]="FeedbackCategory.FEEDBACK"
              data-cy="fb-category-feedback"
            ></app-badge>
            <app-badge
              (feedbackOptionSelected)="onBadgeClick($event)"
              [selectedCategory]="feedback.category"
              [feedbackCategory]="FeedbackCategory.TOOLS"
              data-cy="fb-category-tools"
            ></app-badge>
            <app-badge
              (feedbackOptionSelected)="onBadgeClick($event)"
              [selectedCategory]="feedback.category"
              [feedbackCategory]="FeedbackCategory.OTHER"
              data-cy="fb-category-other"
            ></app-badge>
            <button
              (click)="handleCreateFeedback()"
              class="bg-almostBlack text-sunflowerGold right-0 flex h-11 items-center justify-center gap-2 border border-black p-5 text-xs lg:absolute"
              data-cy="submitFeedbackButton"
            >
              Submit Feedback
              <img class="h-4" src="../../../assets/img/icons/feedback.png" alt="feedback" />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-lightGrayish mb-5 flex flex-col p-5" data-cy="feedback-container">
      <app-text-content-box [headline]="'All Entries'" [headerIcon]="'📓'"></app-text-content-box>
      <app-feedback-list #feedbackListComponent class="overflow-auto pr-1"></app-feedback-list>
    </div>
  </div>
</div>
